<template>
  <div class="row">
    <div class="col-12">
      <h2>Lista de publicidades</h2>
      <Card>
        <div class="row">
          <div class="col"></div>
          <div class="col text-right">
            <router-link to="/publicities/new">
              <base-button type="warning">
                Adicionar
              </base-button>
            </router-link>
          </div>
        </div>
        <PublicityTable />
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Cards/Card'
import PublicityTable from '@/pages/Publicity/PublicityTable'

export default {
  name: 'PublicityPage',
  components: { Card, PublicityTable }
}
</script>
